/*
 * @Author: jlb
 * @Date: 2022-02-28 09:58:29
 * @LastEditTime: 2022-05-11 18:32:44
 * @LastEditors: 汪俊洪
 * @Description: 全屏方法
 */

// 进入全屏
export const setFullScreen = (dom) => {
  const fullScreen = dom
  if (fullScreen.requestFullscreen) {
    fullScreen.requestFullscreen()
  } else if (fullScreen.msRequestFullscreen) {
    fullScreen.msRequestFullscreen()
  } else if (fullScreen.mozRequestFullScreen) {
    fullScreen.mozRequestFullScreen()
  } else if (fullScreen.webkitRequestFullScreen) {
    fullScreen.webkitRequestFullScreen()
  } else {
    this.$message.error('当前浏览器不支持全屏')
  }
}

// 退出全屏
export const outFullScreen = () => {
  if (document.fullscreenElement) {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen()
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen()
    }
  }
}

// 监听退出全屏
export const listenOutFullScreem = () => {
  return new Promise((resolve) => {
    // 要执行的方法
    const fn = () => {
      if (!document.fullscreenElement) {
        window.removeEventListener('resize', fn)
        resolve()
      }
    }
    window.addEventListener('resize', fn)
  })
}
